import { graphql } from '@data-access/graphql'

export const NewsletterSignupDocument = graphql(`
  mutation newsletterSignup($input: NewsletterSignupInput!) {
    registerForNewsletter(input: $input)
  }
`)
